<template>
    <div class="add-team container">
        <div class="row pt-4 mb-3">
            <div class="col-12">
                <div>
                    <a class="back-button" href="/team-members/teams">
                        <img
                            v-bind:src="'/images/arrow_back_blue.svg'"
                            alt
                            style="margin: 0 4px 4px 0;"
                        />
                        Back to Teams
                    </a>
                </div>
            </div>
        </div>
        <div style="max-width: 768px;margin: 0 auto">
            <div class="row pt-md-4 pt-0">
                <div class="col-12">
                    <div class="add-team__title">Create a Team</div>
                    <div class="add-team__desc">Add your team below.</div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="team-name">Team Name</label>
                        <input
                            type="text"
                            class="form-control add-input"
                            id="team-name"
                            placeholder="eg: Operations"
                            v-model="name"
                        />
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <label for="short-description">Short Description</label>
                        <textarea
                            class="form-control add-input"
                            id="short-description"
                            v-model="description"
                            placeholder="Describe what this team does."
                            row="5"
                        ></textarea>
                    </div>
                </div>

                <div class="col-12 mt-4">
                    <div class="form-group">
                        <label for="add-members" class="add-member"
                            >Add Members</label
                        >
                        <div class="position-relative search-wrapper">
                            <input
                                type="text"
                                class="form-control search-input"
                                id="add-members"
                                placeholder="Search by name, title"
                                v-model="q"
                            />
                            <i
                                class="fas fa-search"
                                style="color: #303030;"
                            ></i>
                        </div>
                    </div>
                </div>

                <div class="col-12" style="height: 340px;">
                    <div
                        class="d-flex mt-4 justify-content-between"
                        v-for="(staff, key) in staffs"
                    >
                        <div class="d-flex">
                          <div class="px-1 align-self-center">
                            <div class="mr-2"><user-avatar :avatarURL="staff.avatar_src"></user-avatar></div>
                          </div>
                            <div class="px-1 align-self-center">
                                <div
                                    class="name"
                                    v-text="staff.display_name || staff.name"
                                ></div>
                                <div
                                    class="designation"
                                    v-text="userDesignation(staff)"
                                ></div>
                                <div
                                    v-bind:class="{
                                        name: !(
                                            staff.display_name || staff.name
                                        ),
                                        sub: staff.display_name || staff.name
                                    }"
                                    v-text="staff.email"
                                ></div>
                            </div>
                        </div>
                        <div class="px-1">
                            <button
                                class="btn btn-add font-weight-bold"
                                @click="addMember(staff.id)"
                                v-if="!members.includes(staff.id)"
                            >
                                Add
                                <i class="fas fa-plus"></i>
                            </button>
                            <button
                                class="btn btn-added font-weight-bold"
                                @click="removeMember(staff.id)"
                                v-else
                            >
                                Added
                                <img
                                    v-bind:src="'/images/added.png'"
                                    alt
                                    style="width: 14px;padding-bottom: 3px;"
                                />
                            </button>
                        </div>
                    </div>
                    <empty-state
                        v-if="staffs.length === 0"
                        :page="'staff'"
                    ></empty-state>
                </div>

                <div
                    class="col-md-12 d-flex justify-content-center pagination-section"
                    v-if="paginator.total > 5"
                >
                    <div class style="text-align:center;">
                        <button
                            class="btn btn-paginator"
                            :disabled="paginator.current_page === 1"
                            @click="getPreviousSetOfRecords"
                        >
                            Back
                        </button>

                        <button
                            type="submit"
                            class="btn btn-paginator"
                            :disabled="
                                paginator.current_page === paginator.last_page
                            "
                            @click="getNextSetOfRecords"
                        >
                            Next
                        </button>

                        <small
                            id="emailHelp"
                            v-if="paginator.total > 0"
                            class="form-text text-secondary"
                            v-text="getPaginationText()"
                        ></small>
                    </div>
                </div>

                <div class="col-12 text-center mb-5 floating-btn">
                    <button
                        class="btn btn-done"
                        @click="createGroup()"
                        :disabled="!this.isValidated"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            description: "",
            staffs: [],
            members: [],
            currentUser: {
                role: {
                    slug: ""
                }
            },
            paginator: {
                from: 1,
                last_page: 1,
                per_page: 5,
                to: 4,
                total: 4,
                current_page: 1
            },
            q: ""
        };
    },

    watch: {
        "paginator.current_page"() {
            if (
                this.paginator.current_page > this.paginator.last_page ||
                this.paginator.current_page < 1
            )
                this.paginator.current_page = 1;

            this.getStaffs();
        },

        q() {
            this.executeSearch();
        }
    },

    computed: {
        isValidated() {
            return this.name;
        }
    },

    methods: {
        executeSearch: _.debounce(async function() {
            await this.getStaffs();
        }, 500),

        addMember(staffId) {
            this.members.push(staffId);
        },

        removeMember(staffId) {
            for (let i = 0; i < this.members.length; i++) {
                if (this.members[i] === staffId) {
                    this.members.splice(i, 1);
                }
            }
        },

        async getCurrentUser() {
            const url = "/me";
            this.data = await axios
                .get(url)
                .then(data => (this.currentUser = data.data.data));
        },

        async getStaffs() {
            const url =
                "/team-members/add-list?page=" +
                (this.paginator.current_page || 1) +
                "&q=" +
                this.q;
            this.data = await axios.get(url).then(data => data.data);

            this.staffs = this.data.data;

            const mapKeys = [
                "from",
                "last_page",
                "per_page",
                "to",
                "total"
            ].forEach(key => (this.paginator[key] = this.data[key]));
        },

        async createGroup() {
            this.data = await axios.post("/groups", {
                name: this.name,
                description: this.description,
                team_members: this.members
            });

            location.href = "/team-members/teams";
        },

        isEmptySearchResults() {
            return this.staffs.length === 0 && !!this.q;
        },

        getNextSetOfRecords() {
            this.paginator.current_page++;
        },

        getPreviousSetOfRecords() {
            this.paginator.current_page--;
        },

        getPaginationText() {
            return (
                "Showing " +
                this.paginator.from +
                " – " +
                this.paginator.to +
                " out of " +
                this.paginator.total
            );
        },

        userDesignation(staff) {
            return staff.role_slug === 'freelancer' ? 'External' : staff.designation
        }
    },

    mounted() {
        this.getCurrentUser();
        this.getStaffs();
    }
};
</script>

<style scoped lang="scss">
.add-team {
    .back-button {
        color: #0db4e6;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 22px;
    }

    &__title {
        color: #303030;
        font-family: Lato;
        font-size: 38px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 53.2px;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 24px;
            line-height: 44px;
            text-align: left;
        }
    }

    &__desc {
        color: #606064;
        font-family: "Open Sans", sans-serif;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 28px;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            margin-bottom: 24px;
        }
    }

    label {
        color: #808fa4;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
        line-height: 22px;
    }

    .add-input {
        color: #303030;
        font-family: "Open Sans";
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        @media (max-width: 768px) {
            font-size: 14px;
        }
    }

    .search-wrapper {
        .search-input {
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            border: 1px solid #dce2ed !important;
            background: white;
            padding-left: 2rem;
        }
        .fa-search {
            color: rgb(48, 48, 48);
            position: absolute;
            top: 4px;
            display: flex;
            width: 32px;
            height: 32px;
            align-items: center;
            justify-content: center;
        }
    }

    .add-member {
        color: #303030;
        font-family: Lato;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 28px;

        @media (max-width: 768px) {
            font-size: 14px;
            line-height: 24px;
        }
    }

    .btn-done {
        height: 56px;
        width: 280px;
        color: #ffffff;
        font-family: "Open Sans";
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 22px;
        text-align: center;
        background: #000000;
    }

    .btn-add {
        border-radius: 6px;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
        color: #303030;
        font-family: "Open Sans";
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        /* line-height: 22px; */
        padding: 6px 8px 5px 8px !important;
        width: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .btn-added {
        border-radius: 6px;
        background-color: #82df6b;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
        color: #ffffff;
        font-family: "Open Sans";
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        padding: 6px 8px 5px 8px !important;
        /* line-height: 22px; */
    }
}
@media (max-width: 768px) {
    .floating-btn {
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
    }
}

.btn {
    border-radius: 6px;
    background-color: #5145ff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    border: none;
    color: #fff;
}

:disabled {
    cursor: default;
}

.name {
    color: #303030;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    /* line-height: 22px; */
}

.designation {
    color: #303030;
    font-family: "Open Sans";
    font-size: 10px;
    letter-spacing: 0;
    /* line-height: 22px; */
}

.sub {
    color: #808fa4;
    font-family: "Open Sans";
    font-size: 10px;
    letter-spacing: 0;
    /* line-height: 22px; */
}

:root {
    --avatar-size: 40px;
}

@media (max-width: 769px) {
    .pagination-section {
        margin-bottom: 60px;
    }
}

.btn-paginator {
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    border: none;
    color: #5145ff;
    font-weight: 700;
}
</style>
